import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, loadingStore } from '@pascal/pascal-core';
import { gameMainDrawer } from './gameMainDrawer';
import { setScreenResolution } from '../../helpers';

export const GameMain = observer(() => {
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) return;
    gameMainDrawer.execute(ref.current).then(() => {
      loadingStore.updateLoading({ isPixiLoaded: true });
    });

    if (isMobile()) {
      setScreenResolution(ref.current);
    }
  }, [ref.current]);

  return (
    <>
      {/* <div className='game-backside' /> */}
      <div className='canvas-container'>
        <div className='canvas-wr' ref={ref} />
      </div>
    </>
  );
});
